import React from 'react';
import DriversGridHeader from './DriversGridHeader';
import DriversGridSection from './DriversGridSection';

const DriverGrid: React.FC = () => (
  <>
    <DriversGridHeader />
    <DriversGridSection />
  </>
);

export default DriverGrid;
